/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_70c351d3',
  resizeIsShort: 'resizeIsShort_70c351d3',
  buttonGroup: 'buttonGroup_70c351d3',
  settingsGroup: 'settingsGroup_70c351d3',
  itemCountDropdown: 'itemCountDropdown_70c351d3',
};

export = styles;

loadStyles([{"rawString":".root_70c351d3{display:block}.resizeIsShort_70c351d3{width:400px}.buttonGroup_70c351d3{margin-bottom:40px}.buttonGroup_70c351d3 button{margin-right:20px}.settingsGroup_70c351d3{padding-top:20px}.itemCountDropdown_70c351d3{width:180px}"}]);
/* tslint:enable */